<template>
  <svg
    class="icon-base"
    fill="currentColor"
    viewBox="0 0 16 17"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.89404 11.5906V5.40938C6.89404 5.075 7.30029 4.90625 7.53467 5.14375L10.6065 8.23438C10.7534 8.38125 10.7534 8.61562 10.6065 8.7625L7.53467 11.8531C7.30029 12.0937 6.89404 11.925 6.89404 11.5906ZM8.14404 0.75C12.4253 0.75 15.894 4.21875 15.894 8.5C15.894 12.7812 12.4253 16.25 8.14404 16.25C3.86279 16.25 0.394043 12.7812 0.394043 8.5C0.394043 4.21875 3.86279 0.75 8.14404 0.75ZM8.14404 2.25C4.69092 2.25 1.89404 5.04688 1.89404 8.5C1.89404 11.9531 4.69092 14.75 8.14404 14.75C11.5972 14.75 14.394 11.9531 14.394 8.5C14.394 5.04688 11.5972 2.25 8.14404 2.25Z"
    />
  </svg>
</template>
<script setup></script>
